import {uniqueId} from 'lodash';
import React, {useCallback, useState} from 'react';
import styles from './StartNetworking.module.scss';
import {useI18n} from '../../../../../data/hooks/i18nHooks';

function StartNetworking(props) {
    const {eventId, title = true} = props,
        [clipId] = useState(() => uniqueId('clip-')),
        i18n = useI18n();

    const handleClick = useCallback(() => {
        app.history.push(['/events', eventId, 'start-networking'].join('/'));
    }, [eventId]);

    return (
        <g className={styles.StartNetworking} onClick={handleClick}>
            <circle cx="96" cy="96" r="97" fill="var(--primary_color_lighten_20)" />

            <clipPath id={clipId}>
                <circle cx="96" cy="96" r="97" />
            </clipPath>

            <g clipPath={`url(#${clipId})`}>
                <path
                    fill="var(--primary_color_lighten_5)"
                    d="m 46.65526,193.68924 h 98.97656 c -8.27184,-17.4859 -25.67036,-32.71959 -22.00285,-53.82939 6.45624,-37.15992 46.05935,-57.10735 23.52361,-98.976509 C 121.55466,-6.675895 44.162288,7.50688 38.274538,61.720487 34.675113,94.86393 65.310069,111.62677 68.905912,141.5963 71.287743,161.4472 55.338301,177.37891 46.65526,193.68924 Z"
                />
            </g>

            <text className={styles.icon}>
                <tspan x="96" y="95">
                    ?
                </tspan>
            </text>

            {title ? (
                <text className={styles.startNetworking}>
                    <tspan x="96" y="140">
                        START
                    </tspan>
                    <tspan x="96" y="160">
                        NETWORKING
                    </tspan>
                </text>
            ) : null}
        </g>
    );
}

export default StartNetworking;
